// 引入vue-router
import VueRouter from "vue-router";
import Vue from "vue";
Vue.use(VueRouter);
import i18n from '../assets/i18n'

// 定义routes路由数组
const routes = [{
        path: "/",
        name: "Home",
        meta: { title: i18n.t('route.Home') },
        component: () =>
            import ("@/views/Home/home.vue"),
    },
    {
        path: "/resourceCenter",
        name: "ResourceLibrary",
        meta: { title: i18n.t('route.ResourceLibrary') },
        component: () =>
            import ("@/views/resourceCenter/resourceCenter.vue"),
    },
    {
        path: "/resourceCenterDetail",
        name: "ResourceLibraryDetail",
        meta: { title: i18n.t('route.ResourceLibrary') },
        component: () =>
            import ("@/views/resourceCenter/resourceCenter_detail.vue"),
    },
    //新闻信息
    {
        path: "/newsInformation",
        name: "newsInformation",
        meta: { title: i18n.t('route.newsInformation') },
        component: () =>
            import ("@/views/newsInformation/newsInformation.vue"),
    },
    {
        path: "/news_list",
        name: "news_list",
        meta: { title: i18n.t('home.newsInformation') },
        component: () =>
            import ("@/views/home_item/news_list.vue"),
    },
    {
        path: "/newsDetail",
        name: "newsDetail",
        meta: { title: i18n.t('home.newsInformation') },
        component: () =>
            import ("@/views/home_item/news_detail.vue"),
    },
    {
        path: "/partyBuilding",
        name: "partyBuilding",
        meta: { title: i18n.t('home.newsInformation') },
        component: () =>
            import ("@/views/home_item/partyBuilding.vue"),
    },
    {
        path: "/partyBuildingDetail",
        name: "partyBuildingDetail",
        meta: { title: i18n.t('home.newsInformation') },
        component: () =>
            import ("@/views/home_item/partyBuilding_detail.vue"),
    },
    {
        path: "/companyInfo",
        name: "companyInfo",
        meta: { title: i18n.t('home.company') },
        component: () =>
            import ("@/views/home_item/companyInfo.vue"),
    },
    /** */
    // 客户服务
    {
        path: "/pilotService",
        name: "Pilot",
        meta: { title: i18n.t('route.Pilot') },
        component: () =>
            import ("@/views/pilotService/pilotService.vue"),
    },
    //训练须知
    {
        path: "/pilotService/articleCenter/3011",
        name: "articleCenter/3011",
        meta: { title: i18n.t('pilotService.Training') },
        component: () =>
            import ("@/views/pilotService/articleCenter/articleCenter.vue"),
    },
    //园区服务建议
    {
        path: "/pilotService/articleCenter/3012",
        name: "articleCenter/3012",
        meta: { title: i18n.t('route.Pilot') },
        component: () =>
            import ("@/views/pilotService/articleCenter/articleCenter.vue"),
    },
    // 训练须知\园区服务建议
    {
        path: "/pilotService/articleCenterDetail/:id",
        name: "articleCenterDetail",
        meta: { title: i18n.t('route.Pilot') },
        component: () =>
            import ("@/views/pilotService/articleCenter/articleCenterDetail.vue"),
    },
    // 模拟机计划查询
    {
        path: "/pilotService/planQuery",
        name: "planQuery",
        meta: { title: i18n.t('pilotService.PlanQuery'), requireLogin: true },
        component: () =>
            import ("@/views/pilotService/planQuery/planQuery.vue"),
    },
    // 理论计划查询
    {
        path: "/pilotService/planQuery/second",
        name: "planQuery/second",
        meta: { title: i18n.t('pilotService.TheoreticalPlan'), requireLogin: true },
        component: () =>
            import ("@/views/pilotService/planQuery/planQuery.vue"),
    },
    {
        path: "/pilotService/trafficGuidance",
        name: "trafficGuidance",
        meta: { title: i18n.t('pilotService.TrafficGuidance') },
        component: () =>
            import ("@/views/pilotService/trafficGuidance/trafficGuidance.vue"),
    },
    {
        path: "/pilotService/lostFound",
        name: "lostFound",
        meta: { title: i18n.t('pilotService.LostAndFound'), requireLogin: true },
        component: () =>
            import ("@/views/pilotService/lostFound/lostFound.vue"),
    },
    {
        path: "/pilotService/lostFound/lostFoundDetail",
        name: "lostFoundDetail",
        meta: { title: i18n.t('pilotService.LostAndFound') },
        component: () =>
            import ("@/views/pilotService/lostFound/lostFoundDetail.vue"),
    },
    //问卷调查
    {
        path: "/pilotService/questionnaireInvestigation",
        name: "questionnaireInvestigation",
        meta: { title: i18n.t('pilotService.QuestionnaireInvestigation'), requireLogin: true },
        component: () =>
            import ("@/views/pilotService/questionnaireInvestigation/questionnaireInvestigation.vue"),
    },
    //问卷详情
    {
        path: "/pilotService/questionnaireInvestigation/:id",
        name: "questionnaireDetail",
        meta: { title: i18n.t('pilotService.QuestionnaireInvestigation') },
        component: () =>
            import ("@/views/pilotService/questionnaireInvestigation/questionnaireDetail.vue"),
    },
    /** */
    //关于我们
    {
        path: "/companyProfile/:id",
        name: "companyProfile",
        meta: { title: i18n.t('route.companyProfile') },
        component: () =>
            import ("@/views/companyProfile/companyProfile.vue"),
    },
    //部门介绍
    {
        path: "/departmentIntroduction",
        name: "departmentIntroduction",
        meta: { title: i18n.t('route.companyProfile') },
        component: () =>
            import ("@/views/departmentIntroduction/departmentIntroduction.vue"),
    },
    //产品与服务
    {
        path: "/product",
        name: "product",
        meta: { title: i18n.t('route.ProductCenter') },
        component: () =>
            import ("@/views/productCenter/product.vue"),
    },
    //产品与服务详情
    {
        path: "/productCenter/productCard/:id",
        name: "productCard",
        meta: { title: i18n.t('route.ProductCenter') },
        component: () =>
            import ("@/views/productCenter/productCard.vue"),
    },
    //联系我们
    {
        path: "/ContactUs",
        name: "ContactUs",
        meta: { title: i18n.t('route.Contact') },
        component: () =>
            import ("@/views/ContactUs/ContactUs.vue"),
        children: [
            //联系方式
            {
                path: "/ContactUs",
                name: "ContactUs",
                meta: { title: i18n.t('contactUs.contactInformation') },
                component: () =>
                    import ("@/views/ContactUs/contactInfo.vue"),
            },
            //人才招聘
            {
                path: "/ContactUs/talentRecruitment",
                name: "talentRecruitment",
                meta: { title: i18n.t('contactUs.contactInformation') },
                component: () =>
                    import ("@/views/ContactUs/talentRecruitment.vue"),
            },
        ]
    },
    //职位详情
    {
        path: "/ContactUs/talentRecruitment/positionDetails",
        name: "positionDetails",
        meta: { title: i18n.t('contactUs.contactInformation') },
        component: () =>
            import ("@/views/ContactUs/positionDetails.vue"),
    },
    //法律声明和网站地图
    {
        path: "/legalStatement",
        name: "legalStatement",
        meta: { title: i18n.t('legalAndMap.legalStatement') },
        component: () =>
            import ("@/views/legalAndMap/legalAndMap.vue"),
        children: [
            //法律声明
            {
                path: "/legalStatement",
                name: "legalStatement",
                meta: { title: i18n.t('legalAndMap.legalStatement') },
                component: () =>
                    import ("@/views/legalAndMap/legalStatement.vue"),
            },
            //网站地图
            {
                path: "/legalStatement/siteMap",
                name: "siteMap",
                meta: { title: i18n.t('legalAndMap.siteMap') },
                component: () =>
                    import ("@/views/legalAndMap/siteMap.vue"),
            },
        ]
    },
]

// 实例化VueRouter并将routes添加进去
const router = new VueRouter({
    // 配置URL和组价直接的映射关系
    routes,
    // history模式 
    mode: 'history'
})

// 抛出这个这个实例对象方便外部读取以及访问
export default router